type SortOrder = 'asc' | 'desc' | 'none';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function sortData<T extends Record<string, any>>(
  data: T[],
  colKey: string,
  order: SortOrder,
): T[] {
  if (order === 'none') return [...data];

  return [...data].sort((a, b) => {
    const valueA = a[colKey] ?? '';
    const valueB = b[colKey] ?? '';

    // Attempt to parse numeric-like strings as numbers first
    const isNumericA = !isNaN(Number(valueA));
    const isNumericB = !isNaN(Number(valueB));

    if (isNumericA && isNumericB) {
      const numA = Number(valueA);
      const numB = Number(valueB);
      return order === 'asc' ? numA - numB : numB - numA;
    }

    // Fall back to string comparison
    const [strA, strB] = [
      valueA.toString().toLowerCase(),
      valueB.toString().toLowerCase(),
    ];
    return order === 'asc'
      ? strA > strB
        ? 1
        : strA < strB
          ? -1
          : 0
      : strA < strB
        ? 1
        : strA > strB
          ? -1
          : 0;
  });
}

export function toggleSortOrder(currentOrder: SortOrder): SortOrder {
  return currentOrder === 'none'
    ? 'asc'
    : currentOrder === 'asc'
      ? 'desc'
      : 'none';
}

export function getSortIndicator(order: SortOrder): string {
  return order === 'asc' ? '🠉' : order === 'desc' ? '🠋' : '🠉';
}
